module.exports = __webpack_public_path__ + "img/raketa_dopravanahoru.636142ca.png";